import React, { useState } from "react";
import { cn } from "@/lib/utils";
import { Wordmark } from "@/components/common/Wordmark";
import { PanelLeftClose, PanelLeftOpen, CircleHelp } from "lucide-react";
import { SidebarBody } from "@/components/shell/SidebarBody";

export function SidebarNav() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside
      data-testid="sidebar-nav"
      className={cn(
        "sticky top-0 hidden h-screen shrink-0 flex-col border-r md:flex",
        collapsed ? "w-[76px]" : "w-[220px]",
      )}
      style={{ background: "linear-gradient(180deg, var(--chrome) 0%, var(--chrome-2) 52%, var(--chrome) 100%)", borderColor: "var(--chrome-border)", boxShadow: "inset -1px 0 0 var(--chrome-border)" }}
    >
      {/* Brand row */}
      <div className={cn("flex h-14 items-center px-4", collapsed && "justify-center px-0")}>
        <div className={cn("flex items-center", collapsed ? "justify-center" : "flex-1")}>
          <Wordmark collapsed={collapsed} />
        </div>
        {!collapsed && (
          <button
            type="button"
            onClick={() => setCollapsed(true)}
            className="flex h-8 w-8 items-center justify-center rounded-md text-[color:var(--chrome-text-muted)] transition-colors hover:bg-[color:var(--chrome-hover)] hover:text-[color:var(--chrome-text)]"
            data-testid="sidebar-collapse-button"
            aria-label="Collapse sidebar"
          >
            <PanelLeftClose className="h-4 w-4" />
          </button>
        )}
      </div>
      {collapsed && (
        <div className="flex justify-center py-2">
          <button
            type="button"
            onClick={() => setCollapsed(false)}
            className="flex h-8 w-8 items-center justify-center rounded-md text-[color:var(--chrome-text-muted)] transition-colors hover:bg-[color:var(--chrome-hover)] hover:text-[color:var(--chrome-text)]"
            data-testid="sidebar-expand-button"
            aria-label="Expand sidebar"
          >
            <PanelLeftOpen className="h-4 w-4" />
          </button>
        </div>
      )}

      <SidebarBody collapsed={collapsed} />

      {/* Footer hint */}
      {!collapsed && (
        <div className="border-t px-3 py-3" style={{ borderColor: "var(--chrome-border)" }}>
          <div className="flex items-center justify-between gap-2 rounded-lg px-3 py-2 text-[12px] text-[color:var(--chrome-text-muted)]">
            <span className="inline-flex items-center gap-2"><CircleHelp className="h-4 w-4 text-[color:var(--chrome-text-muted)]" /> Need help?</span>
            <span className="text-[color:var(--chrome-text-muted)]">›</span>
          </div>
        </div>
      )}
    </aside>
  );
}
